module.exports = __webpack_public_path__ + "static/media/em-223.8528a9ce.png";